export default "__VITE_ASSET__c7514591__"